<!--174 ReworkVariantFeaturesJob-->

<div class="dx-field">
  <div class="dx-field-label">{{ 'Nach Kategorien filtern' | translate }}</div>
  <div class="dx-field-value">
    <dx-switch [(value)]="filterByCategories" (onValueChanged)="onFilterByCategoriesChanged()"></dx-switch>
  </div>
</div>

<div *ngIf="filterByCategories" class="dx-field" style="height: 300px">
  <dx-load-indicator *ngIf="!isCategoryFilterLoaded"></dx-load-indicator>
    <dx-tree-list #categoryTreeList
                  *ngIf="isCategoryFilterLoaded"
                [(dataSource)]="categoryFilters"
                [(selectedRowKeys)]="checkedCategories"
                dataStructure="tree"
                  keyExpr="id"
                itemsExpr="items"
                showCheckBoxesMode="selectAll"
                  (onSelectionChanged)="getRelevantFeatureSystemsInCatalog($event)"
                [ngStyle]="{'height': 'inherit'}">
    <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection mode="multiple" [recursive]="true"></dxo-selection>
        <dxo-scrolling [preloadEnabled]="true" [useNative]="true"></dxo-scrolling>
    <dxi-column dataField="text" caption="{{ 'Kategorie' | translate }}"></dxi-column>
  </dx-tree-list>
</div>

<div class="dx-field">
  <div class="dx-field-label">{{ 'Variantenmerkmale mit Multivalues ignorieren' | translate }}</div>
  <div class="dx-field-value">
    <dx-switch [(value)]="ignoreMultivalues"></dx-switch>
  </div>
</div>

<div class="dx-field">
    <div class="dx-field-label">{{ 'Merkmalsystem' | translate }}</div>
    <div class="dx-field-value">
        <dx-select-box [dataSource]="featureSystemsInCatalog" [(value)]="relevantFeatureSystemId" displayExpr="name"
                       valueExpr="id"></dx-select-box>
    </div>
</div>

<div class="dx-field">
  <dx-button text="{{ 'Variantenmerkmale analysieren' | translate }}"
             type="default"
             [disabled]="filterByCategories && (!checkedCategories || checkedCategories.length === 0)"
             (onClick)="analyzeVariantFeatures()"></dx-button>
</div>

<dx-load-indicator *ngIf="isAnalyzing" id="large-indicator" height="60" width="60"></dx-load-indicator>

<dx-data-grid *ngIf="hasAnalyzed"
              [dataSource]="featureInCatalog"
              [showBorders]="true"
              noDataText="{{ 'ReworkVariantFeaturesNoDataMessage' | translate }}"
              [style.marginTop.px]="25">
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxo-paging [pageSize]="50"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20, 50, 100]" [showNavigationButtons]="true"></dxo-pager>
  <dxi-column dataField="name" caption="{{ 'Merkmalsname' | translate }}"></dxi-column>
  <dxi-column dataField="unit" caption="{{ 'Merkmalseinheit' | translate }}"></dxi-column>
  <dxi-column caption="{{ 'Variantenmerkmal' | translate }}" cellTemplate="isVariantTemplate" [allowSorting]="false" [allowFiltering]="false"></dxi-column>
  <div *dxTemplate="let model of 'isVariantTemplate'">
    <dx-switch [value]="model.data.isVariant" (onValueChanged)="setIsVariant(model.data, $event.value)"></dx-switch>
  </div>
</dx-data-grid>
